import React from 'react';

const Refresh = (props: object) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.6673 8.00065C14.6673 11.6807 11.6807 14.6673 8.00065 14.6673C4.32065 14.6673 2.07398 10.9607 2.07398 10.9607M2.07398 10.9607H5.08732M2.07398 10.9607V14.294M1.33398 8.00065C1.33398 4.32065 4.29398 1.33398 8.00065 1.33398C12.4473 1.33398 14.6673 5.04065 14.6673 5.04065M14.6673 5.04065V1.70732M14.6673 5.04065H11.7073"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Refresh;
